<template>
    <div class="statusChart" ref="chart"></div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import DarkTheme from "@amcharts/amcharts4/themes/dark";
    import Animated from "@amcharts/amcharts4/themes/animated";


    am4core.useTheme(Animated);
    am4core.useTheme(DarkTheme);

    export default {

        props: {
            data: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {
                chart: null,
                subscribedChartClass: 'mt-3'
            }
        },

        watch: {
            data(newData) {
                this.chart.data = newData;
            }
        },

        methods: {},

        mounted() {
            this.chart = am4core.create(this.$refs.chart, am4charts.PieChart);
            this.chart.hiddenState.properties.opacity = 0; // Fade in
            this.chart.innerRadius = am4core.percent(40);
            this.chart.startAngle = 0;
            this.chart.endAngle = 360;

            // Add data
            this.chart.data = this.data;

            // Add and configure Series
            let pieSeries = this.chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "value";
            pieSeries.dataFields.category = "name";
            pieSeries.slices.template.cornerRadius = 0;
            pieSeries.slices.template.stroke = am4core.color("#eee");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;
            pieSeries.labels.template.disabled = true;
            pieSeries.ticks.template.disabled = true;
            pieSeries.slices.template.states.getKey("hover").properties.shiftRadius = 0;
            pieSeries.slices.template.states.getKey("hover").properties.scale = 1.1;

            pieSeries.colors.list = [
                am4core.color("#1E88E5"),
                am4core.color("#999999"),
                am4core.color("#555555"),
            ];
        },
    }
</script>

<style scoped>
    .statusChart {
        height: 250px;
    }
</style>
